import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPurchase = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "purchase",
	"data-name": "purchase",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-6 -6 36 36",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "price_tag",
		children: [/* @__PURE__ */ _jsx("polygon", {
			className: "plan2plate-icon",
			points: "3.41 1.5 1.5 3.41 1.5 11.04 12.96 22.5 22.5 12.96 11.04 1.5 3.41 1.5"
		}), /* @__PURE__ */ _jsx("circle", {
			className: "plan2plate-icon",
			cx: 6.27,
			cy: 6.27,
			r: 1.91
		})]
	})]
});
const ForwardRef = forwardRef(SvgPurchase);
export default ForwardRef;
